import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import API, { formatApiErrorDetail } from "../lib/api";
import AdminLayout from "./AdminLayout";
import { useAppT } from "../components/home/i18n";
import { UserX, Download, XCircle, CheckCircle2 } from "lucide-react";

const ICONS = { account_deletion: UserX, data_export: Download, consent_withdrawal: XCircle };

export default function AdminAccountRequests() {
  const { a } = useAppT();
  const [status, setStatus] = useState("open");
  const [requests, setRequests] = useState([]);
  const load = async () => { const { data } = await API.get("/admin/account-requests", { params: { status } }); setRequests(data.requests); };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [status]);

  const resolve = async (id) => {
    try { await API.post(`/admin/account-requests/${id}/resolve`, { note: "Actioned by admin" }); toast.success(a.adminReqs.requestResolved); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  return (
    <AdminLayout>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h1 className="font-serif text-3xl text-[#173A2C]">{a.adminReqs.title}</h1>
        <div className="flex gap-1 rounded-full border border-[#E8E4DB] bg-white p-1">
          {["open", "resolved", "all"].map((s) => (
            <button key={s} data-testid={`acctreq-${s}`} onClick={() => setStatus(s)} className={`rounded-full px-3 py-1 text-sm ${status === s ? "bg-[#1F4A38] text-white" : "text-[#5C5855]"}`}>{a.adminReqs.filters[s]}</button>
          ))}
        </div>
      </div>
      <p className="mt-1 text-xs text-[#8a8580]">{a.adminReqs.sub}</p>

      <div className="mt-5 space-y-3" data-testid="acct-requests-list">
        {requests.length === 0 && <div className="text-sm text-[#5C5855]">{a.adminReqs.noRequests}</div>}
        {requests.map((r) => {
          const Icon = ICONS[r.type] || UserX;
          const label = a.adminReqs.labels[r.type] || r.type;
          return (
            <div key={r.id} data-testid={`acctreq-${r.id}`} className="flex flex-wrap items-center justify-between gap-2 rounded-md border border-[#E8E4DB] bg-white p-4">
              <div className="flex items-center gap-3">
                <Icon className="h-5 w-5 text-[#1F4A38]" />
                <div>
                  <div className="text-sm font-semibold text-[#2C2A29]">{label}</div>
                  <div className="text-xs text-[#5C5855]">{r.user_email} · {a.respMap[r.user_role] || r.user_role} · {new Date(r.created_at).toLocaleString()}</div>
                  {r.detail && <div className="text-xs text-[#5C5855]">{r.detail}</div>}
                </div>
              </div>
              {r.status === "open"
                ? <button data-testid={`resolve-${r.id}`} onClick={() => resolve(r.id)} className="inline-flex items-center gap-1 rounded-full bg-[#1F4A38] px-4 py-1.5 text-xs font-semibold text-white"><CheckCircle2 className="h-3.5 w-3.5" /> {a.adminReqs.markResolved}</button>
                : <span className="rounded-full bg-[#2E6B4B]/12 px-2 py-0.5 text-[11px] font-semibold text-[#2E6B4B]">{a.adminReqs.resolvedWord}</span>}
            </div>
          );
        })}
      </div>
    </AdminLayout>
  );
}
